import { fetchListingsAndFilters } from '../fetchers';
import {
    updateListingData,
    getInventorySortOption,
    removeEmptyMakeFilter,
    getCarsAvailableText,
} from '../utilities';
import { filtersReference as initialFilters } from '../reference';
import setDdpFiltersData from './setDdpFiltersData';
import {
    inventoryFiltersDuck,
    inventoryMetadataDuck,
    inventoryDuck,
    inventoryResultsDuck,
    inventorySortDuck,
    inventoryUrlsDuck,
    inventorySupportMakesDuck,
    showInventoryDuck,
    ownersDuck,
} from '../ducks';

export default ({ isKbb, query, showInventory }) => async (dispatch, getState) => {
    try {
        const brand = isKbb ? 'KBB' : 'ATC';
        const sortOption = getInventorySortOption(brand);
        const queryParams = {
            ...query,
            channel: brand,
            marketExtension: 'include',
            sortBy: query.sortBy ? query.sortBy : sortOption,
            stats: ['year', 'derivedprice'],
        };

        const data = await fetchListingsAndFilters({ query: queryParams });
        data.supportMakes = removeEmptyMakeFilter(data.filters?.makeCode?.options);
        const updatedListings = await updateListingData(data.listings, data.owner, brand);

        setDdpFiltersData({
            filtersDuck: inventoryFiltersDuck,
            initialFilters,
            filtersData: data.filters || {},
            filterGroupsData: data.filterGroups || {},
            queryParams,
        })(dispatch, getState);

        dispatch(ownersDuck.creators.addOwners([updatedListings.owner]));
        dispatch(inventoryDuck.creators.addInventory(!updatedListings.inventory ? [] : updatedListings.inventory));
        dispatch(inventoryResultsDuck.creators.setActiveResults(updatedListings.activeResults));
        dispatch(inventorySortDuck.creators.setSort(queryParams.sortBy));
        dispatch(inventoryResultsDuck.creators.setCount(data.totalResultCount));
        dispatch(inventoryUrlsDuck.creators.setKey('results', updatedListings.urls));
        dispatch(inventorySupportMakesDuck.creators.set(data.supportMakes));
        dispatch(inventoryResultsDuck.creators.setStats(data.stats || {}));
        dispatch(showInventoryDuck.creators.set(data.listings?.length > 0 || showInventory));

        const state = getState();
        const inventoryMetadata = inventoryMetadataDuck.selectors.getDuckState(state) || {};
        dispatch(inventoryMetadataDuck.creators.setKeys({
            title: inventoryMetadata.title?.replace(
                '| Cars Available',
                getCarsAvailableText(data.totalResultCount)
            ),
        }));

        return { success: true, data };
    } catch (error) {
        console.error('Failed to set inventory data:', error);
        return { success: false, error };
    }
};
